// Add A Data Attribure to each slide to setup for reveal
export let setupPovertyPopups = () => {
  let i = 1;
  gsap.set('.single-poverty-pop-up', {
    transformOrigin:'center left',
    opacity:0,
    rotationY:20,
    x:-80,
    //scale:0.7,
    zIndex:1,
  });
  $('.single-poverty-pop-up').each(function() {
    $(this).attr('data-pop-up', i);
    i++
  })
}

export let clickPovertyPopups = () => {
  $('.povertyPopupTrigger').each( function(){

    // Get The Manually Added Pop Up Trigger Number
    let thisPopup = $(this).attr('data-pop-up-trigger');
      // Get The Coresponding Popup which is created automatically in setupPovertyPopups(); above
    let thisPopupModal = $('*[data-pop-up="'+ thisPopup+'"]');       
    
    

    $(this).on('click', function(){
      
      // Setup the TL To animate the one out
      let oneTL = gsap.timeline({paused:true})

      // Setup the TL for All to close
      let allTL = gsap.timeline({paused:true,
        onComplete: function() {
          // After it's done play out the new one
          oneTL.play();
          $('.poverty-popup-container').addClass('openModal');
        }
      })

      // Setup a close Animation
      let closeTL = gsap.timeline({paused:true})

      // Reverse them all on close
      closeTL.to('.single-poverty-pop-up', {
        opacity:0,
        rotationY:20,
        x:-80,
        //scale:0.7,
        // zIndex:1,
        duration:0.3, 
        ease:"circ.out",
        onComplete: function() {
          gsap.set('.single-poverty-pop-up', {zIndex:1});
          $('.poverty-popup-container').removeClass('openModal');
        }
      })

      // Reverse Them All Before Playing a new one
      allTL.to('.single-poverty-pop-up', {
        opacity:0, 
        rotationY:20,
        x:-80,
        //scale:0.7,
        // zIndex:1,
        duration:0.3, 
        ease:"circ.out",
        onComplete: function() {
          gsap.set('.single-poverty-pop-up', {zIndex:1});
          $('.poverty-popup-container').removeClass('openModal');
        }
      })

      // Play Out the One that weas clicked
      oneTL.to(thisPopupModal, {
        opacity:1, 
        rotationY:0,
        x:0, 
        scale:1,
        zIndex:2,
        duration:0.3, 
        ease:"circ.out",
        onComplete: function() {
          $('.poverty-popup-container').addClass('openModal');
        }
      });

      
      // If There's an open modal close it and then play the new modal Timeline
      if($('.poverty-popup-container').hasClass('openModal')){
        allTL.play()
      // If Nothing is open just play it out  
      } else {
        oneTL.play();
      }

      // Play the Close all Timeline on clicking Close
      $('.povertyPopupClose').on('click', function() {
        closeTL.play();
      })
      
    })
  })
}